import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import EndOfStayQuestionnairesProcessingPage from './end-of-stay-questionnaires-processing'
import EndOfStayTemplateCreatePage from './end-of-stay-template-create'
import EndOfStayTemplateListPage from './end-of-stay-template-list'
import EndOfStayTemplateQuestionsPage from './end-of-stay-template-questions'
import EndOfStayTemplateUpdatePage from './end-of-stay-template-update'

export const endOfStayTemplateRoutes: Route[] = [
  {
    path: Paths.SURVEY_END_OF_STAY_TEMPLATES_LIST_PAGE,
    element: <EndOfStayTemplateListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.SURVEY_END_OF_STAY_TEMPLATE_CREATE_PAGE,
    element: <EndOfStayTemplateCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.SURVEY_END_OF_STAY_TEMPLATE_UPDATE_PAGE,
    element: <EndOfStayTemplateUpdatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.SURVEY_END_OF_STAY_TEMPLATE_QUESTIONS_LIST_PAGE,
    element: <EndOfStayTemplateQuestionsPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.SURVEY_END_OF_STAY_QUESTIONNAIRES_PROCESSING_PAGE,
    element: <EndOfStayQuestionnairesProcessingPage />,
    roles: [RoleEnum.ADMIN]
  }
]
